/**
* @file 资源管理-车辆资源-创建车辆
* */
<template>
  <div class="vehicleCreate">
    <!-- 步骤条 -->
    <el-steps :active="currentStep" finish-status="success" align-center class="vehicle-steps">
      <el-step title="车辆信息" description="号牌、型号、证件照片"></el-step>
      <el-step title="确认提交" description="核对信息并提交"></el-step>
    </el-steps>

    <!-- Step 1: 车辆信息 -->
    <div v-show="currentStep === 0">
      <el-form label-width="120px" label-position="left" :model="form" ref="formStep1" :rules="rules">
        <div class="formTitle">基本信息</div>
        <div class="form-layout">
          <div class="form-fields">
            <el-form-item label="机构名称" prop="organizationId">
              <el-select v-model="form.organizationId" filterable
                v-if="mixinUserInfo && mixinUserInfo.organizationType === 1" placeholder="请选择机构名称">
                <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name"></el-option>
              </el-select>
              <span v-else>{{ organizations && organizations[0] && organizations[0].name }}</span>
            </el-form-item>
            <el-form-item label="车辆号牌" prop="licenseNo">
              <div style="display:flex;align-items:center;gap:10px">
                <el-input v-model="form.licenseNo" maxlength="8" placeholder="例：川A12345"
                  @input="onLicenseInput" style="flex:1">
                  <template slot="suffix">
                    <span v-if="form.licenseNo && form.licenseNo.length >= 7"
                      style="color:#67C23A;font-size:14px">✓</span>
                  </template>
                </el-input>
                <span v-if="form.licenseNo && form.licenseNo.length >= 7"
                  :style="getPlateStyle(form.licenseNo)" style="flex-shrink:0">
                  {{ formatPlateNumber(form.licenseNo) }}
                </span>
              </div>
              <p class="field-tip">号牌字母自动转为大写，输入完整后自动预览</p>
            </el-form-item>
            <el-form-item label="号牌颜色" prop="licenseColor">
              <div style="display:flex;align-items:center;gap:10px">
                <el-select v-model="form.licenseColor" filterable placeholder="请选择号牌颜色" style="flex:1">
                  <el-option v-for="item in $const.LICENSECOLOR" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-tag v-if="autoColorHint" type="success" size="small" style="flex-shrink:0">已自动推断</el-tag>
              </div>
              <p class="field-tip" v-if="autoColorHint" style="color:#67C23A">{{ autoColorHint }}</p>
            </el-form-item>
            <el-form-item label="车辆识别代号" prop="vin">
              <el-input v-model="form.vin" maxlength="17" placeholder="17位VIN码"
                @input="onVinInput">
                <template slot="suffix">
                  <span v-if="form.vin && form.vin.length === 17" style="color:#67C23A;font-size:14px">✓</span>
                  <span v-else-if="form.vin" style="color:#909399;font-size:12px">{{ form.vin.length }}/17</span>
                </template>
              </el-input>
              <p class="field-tip">VIN码自动转为大写，不含I/O/Q字母</p>
            </el-form-item>
            <el-form-item label="使用性质" prop="useCharacter">
              <el-select v-model="form.useCharacter" filterable placeholder="请选择使用性质">
                <el-option v-for="item in useCharacterOptions" :label="item.label" :key="item.value" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="核载人数" prop="vehicleSeat">
              <el-select v-model="form.vehicleSeat" filterable placeholder="请选择核载人数">
                <el-option v-for="item in $const.SEATNUMBER" :label="item.label" :key="item.value" :value="item.value"></el-option>
              </el-select>
              <p class="field-tip">5/7/8/9座支持选座功能</p>
            </el-form-item>
            <el-form-item label="注册日期" prop="registerDate">
              <el-date-picker v-model="form.registerDate" type="date" placeholder="选择注册日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="车辆型号" prop="vehicleModel">
              <choose-model :modelValue.sync="form.vehicleModel"></choose-model>
            </el-form-item>
            <el-form-item label="车身颜色" prop="vehicleColor">
              <el-select v-model="form.vehicleColor" filterable placeholder="请选择车身颜色">
                <el-option v-for="item in $const.VEHICLECOLOR" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车辆编号" prop="vehicleNo">
              <el-input v-model="form.vehicleNo" maxlength="10" placeholder="可选，仅限数字和字母"
                @input="onVehicleNoInput"></el-input>
            </el-form-item>
          </div>
          <div class="form-images">
            <el-form-item label="行驶证正面" prop="drivingLicenseFront">
              <up-img :file.sync="form.drivingLicenseFront" width="180" height="110"></up-img>
              <p class="field-tip">上传行驶证主页</p>
            </el-form-item>
            <el-form-item label="行驶证背面" prop="drivingLicenseBack">
              <up-img :file.sync="form.drivingLicenseBack" width="180" height="110"></up-img>
            </el-form-item>
            <el-form-item label="车辆照片" prop="vehiclePhoto">
              <up-img :file.sync="form.vehiclePhoto" width="180" height="110"></up-img>
            </el-form-item>
          </div>
        </div>

        <div class="formTitle">道路运输证</div>
        <el-form-item label="证件照片" prop="roadTransportCertificate">
          <up-img :file.sync="form.roadTransportCertificate" width="180" height="110"></up-img>
        </el-form-item>
      </el-form>
    </div>

    <!-- Step 2: 确认提交 -->
    <div v-show="currentStep === 1">
      <div class="formTitle">信息确认</div>
      <el-descriptions :column="2" border class="confirm-desc">
        <el-descriptions-item label="机构名称">{{ orgName }}</el-descriptions-item>
        <el-descriptions-item label="车辆号牌">
          <span style="font-weight:600;color:#303133">{{ form.licenseNo }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="号牌颜色">{{ licenseColorLabel }}</el-descriptions-item>
        <el-descriptions-item label="车辆识别代号">{{ form.vin }}</el-descriptions-item>
        <el-descriptions-item label="使用性质">{{ form.useCharacter }}</el-descriptions-item>
        <el-descriptions-item label="核载人数">{{ form.vehicleSeat }}座</el-descriptions-item>
        <el-descriptions-item label="注册日期">{{ form.registerDate ? new Date(form.registerDate).toLocaleDateString() : '—' }}</el-descriptions-item>
        <el-descriptions-item label="车辆型号">{{ form.vehicleModel }}</el-descriptions-item>
        <el-descriptions-item label="车身颜色">{{ form.vehicleColor }}</el-descriptions-item>
        <el-descriptions-item label="车辆编号">{{ form.vehicleNo || '—' }}</el-descriptions-item>
      </el-descriptions>
      <div class="confirm-images">
        <div class="confirm-img-item" v-if="form.drivingLicenseFront">
          <p>行驶证正面</p>
          <el-image :src="form.drivingLicenseFront" fit="cover" style="width:150px;height:90px;border-radius:4px"></el-image>
        </div>
        <div class="confirm-img-item" v-if="form.drivingLicenseBack">
          <p>行驶证背面</p>
          <el-image :src="form.drivingLicenseBack" fit="cover" style="width:150px;height:90px;border-radius:4px"></el-image>
        </div>
        <div class="confirm-img-item" v-if="form.vehiclePhoto">
          <p>车辆照片</p>
          <el-image :src="form.vehiclePhoto" fit="cover" style="width:150px;height:90px;border-radius:4px"></el-image>
        </div>
        <div class="confirm-img-item" v-if="form.roadTransportCertificate">
          <p>道路运输证</p>
          <el-image :src="form.roadTransportCertificate" fit="cover" style="width:150px;height:90px;border-radius:4px"></el-image>
        </div>
      </div>
      <div style="margin-top:16px;color:#909399;font-size:12px">
        <i class="el-icon-info"></i> 提交后车辆号牌和VIN码不可修改，请仔细核对
      </div>
    </div>

    <!-- 底部操作按钮 -->
    <div class="form-button">
      <el-button v-if="currentStep > 0" @click="prevStep">上一步</el-button>
      <el-button v-if="currentStep < 1" type="primary" @click="nextStep">下一步</el-button>
      <el-button v-if="currentStep === 1" type="primary" @click="submitForm" :loading="loading">确认提交</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import chooseModel from './chooseModel.vue';
export default {
  name: "vehicleCreate",
  components: { chooseModel },
  data() {
    const licenseValidator = (rule, value, callback) => {
      const xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z][A-Z](([A-Z0-9]{6}$)|([A-Z0-9]{5}$))/;
      const creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z][A-Z][A-Z0-9]{4}[A-Z0-9挂学警港澳]$/;
      if (!value) {
        callback(new Error("请输入车辆号牌码"));
      } else if (value.length !== 7 && value.length !== 8) {
        callback(new Error("车辆号牌为7-8位"));
      } else if (value.length === 7 && !creg.test(value)) {
        callback(new Error("请输入正确的车辆号牌码"));
      } else if (value.length === 8 && !xreg.test(value)) {
        callback(new Error("请输入正确的新能源车辆号牌码"));
      } else {
        callback();
      }
    };
    const vinValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入车辆识别代号（VIN）"));
      } else if (!/^[A-HJ-NPR-Z\d]{17}$/.test(value)) {
        callback(new Error("VIN码为17位，不含字母I/O/Q"));
      } else {
        callback();
      }
    };
    return {
      currentStep: 0,
      autoColorHint: '',
      form: {
        organizationId: null,
        licenseNo: '',
        licenseColor: '',
        vin: '',
        useCharacter: '',
        vehicleSeat: '',
        registerDate: '',
        vehicleModel: '',
        vehicleColor: '',
        vehicleNo: '',
        drivingLicenseFront: '',
        drivingLicenseBack: '',
        vehiclePhoto: '',
        roadTransportCertificate: '',
      },
      rules: {
        organizationId: [{ required: true, message: "请选择机构名称" }],
        licenseNo: [{ required: true, validator: licenseValidator, trigger: ['blur', 'change'] }],
        licenseColor: [{ required: true, message: "请选择号牌颜色" }],
        vin: [{ required: true, validator: vinValidator, trigger: ['blur', 'change'] }],
        useCharacter: [{ required: true, message: "请选择使用性质" }],
        vehicleSeat: [{ required: true, message: "请选择核载人数" }],
        registerDate: [{ required: true, message: "请选择注册日期" }],
        vehicleModel: [{ required: true, message: "请输入车辆型号" }],
        vehicleColor: [{ required: true, message: "请选择车身颜色" }],
        drivingLicenseFront: [{ required: true, message: "请上传行驶证正面" }],
        drivingLicenseBack: [{ required: true, message: "请上传行驶证背面" }],
        vehiclePhoto: [{ required: true, message: "请上传车辆照片" }],
        roadTransportCertificate: [{ required: true, message: "请上传道路运输证" }],
      },
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date('1949-10-01').getTime() || time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    useCharacterOptions() {
      return this.mixinUserInfo && (this.mixinUserInfo.platformType === 1 || this.mixinUserInfo.platformType === 2)
        ? this.$const.CUSTOMUSENATURE
        : this.$const.USENATURE;
    },
    orgName() {
      const org = this.organizations && this.organizations.find(o => o.id === this.form.organizationId);
      return org ? org.name : (this.organizations && this.organizations[0] && this.organizations[0].name) || '';
    },
    licenseColorLabel() {
      const item = this.$const.LICENSECOLOR && this.$const.LICENSECOLOR.find(c => c.value === this.form.licenseColor);
      return item ? item.label : this.form.licenseColor || '—';
    },
  },
  async created() {
    await this.mixinOrganizations();
    if (this.mixinUserInfo && this.mixinUserInfo.organizationType === 2 && this.organizations && this.organizations[0]) {
      this.$set(this.form, "organizationId", this.organizations[0].id);
    }
  },
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    onLicenseInput(val) {
      this.form.licenseNo = val.toUpperCase();
      this.inferLicenseColor();
    },
    inferLicenseColor() {
      const plate = this.form.licenseNo;
      if (!plate || plate.length < 7) {
        this.autoColorHint = '';
        return;
      }
      const isNewEnergy = plate.length === 8 || /[DF]/.test(plate.substring(2, 3)) || /[DF]$/.test(plate);
      const colors = this.$const.LICENSECOLOR || [];
      if (isNewEnergy) {
        const green = colors.find(c => c.label && c.label.includes('绿'));
        if (green) {
          this.form.licenseColor = green.value;
          this.autoColorHint = '已识别为新能源号牌，自动选择绿色';
        }
      } else {
        const blue = colors.find(c => c.label && c.label.includes('蓝'));
        if (blue) {
          this.form.licenseColor = blue.value;
          this.autoColorHint = '已识别为传统车牌，自动选择蓝色';
        }
      }
    },
    onVinInput(val) {
      this.form.vin = val.toUpperCase();
    },
    onVehicleNoInput(val) {
      this.form.vehicleNo = val.replace(/[^0-9a-zA-Z]/g, '').toUpperCase();
    },
    nextStep() {
      this.$refs.formStep1.validate((valid) => {
        if (valid) {
          this.currentStep = 1;
        } else {
          this.$message.warning("请完善必填信息后再继续");
        }
      });
    },
    prevStep() {
      this.currentStep = 0;
    },
    submitForm() {
      this.postFn();
    },
    async postFn() {
      this.loading = true;
      const url = "/api/v1/manage/vehicle";
      const params = {
        ...this.form,
        registerDate: new Date(this.form.registerDate).getTime() / 1000,
      };
      const { code } = await this.$axios.post(url, params);
      if (code === 1) {
        this.$message.success("车辆创建成功！");
        this.$router.go(-1);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="less" scoped>
.vehicleCreate {
  width: 100%;
  padding: 0 0 80px;
  position: relative;

  .vehicle-steps {
    padding: 20px 40px 30px;
    background: #fff;
    margin-bottom: 20px;
    border-radius: 4px;
  }

  .formTitle {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    padding: 16px 0 12px;
    border-bottom: 1px solid #EBEEF5;
    margin-bottom: 20px;
  }

  .form-layout {
    display: flex;
    gap: 40px;
    align-items: flex-start;

    .form-fields {
      flex: 1;
      max-width: 460px;
    }

    .form-images {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  .field-tip {
    margin: 2px 0 0;
    font-size: 11px;
    color: #909399;
    line-height: 1.4;
  }

  .confirm-desc {
    margin-top: 8px;
    /deep/ .el-descriptions-item__label {
      width: 120px;
    }
  }

  .confirm-images {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    margin-top: 20px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 4px;

    .confirm-img-item {
      text-align: center;
      p {
        font-size: 12px;
        color: #606266;
        margin-bottom: 6px;
      }
    }
  }

  .form-button {
    width: calc(100% - 200px);
    background: #fff;
    padding: 14px 20px;
    position: fixed;
    bottom: 0;
    right: 0;
    border-top: 1px solid #EBEEF5;
    display: flex;
    gap: 12px;
    z-index: 10;
  }
}
</style>
